import Channels from '../base/channels';
import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import easesCustom from '../fx/CustomEases';

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.landmark = this.DOM.view.querySelector('.jsLandmark')
    this.DOM.anchorInTheFlow = this.DOM.view.parentElement.querySelector('.models-slider-anchor')
    //! VARS
    this.VARS = {}
    this.VARS.TOTAL_SLIDES = this.ref.step.length - 1
    this.VARS.SNAPS = [0];
    this.VARS.NEW_SLIDE = 0
    this.VARS.CURRENT_SLIDE = -1
    this.VARS.RATIO_VIEWPORT = (Env.mobileCSS)?2:4
    this.VARS.skinValue = this.DOM.view.getAttribute('data-skin')

    setTimeout(() => {
      this.createSnapsPoints()
      gsap.delayedCall(.1,()=>{
        this._fx()
      })
    }, Env.timingDelayFx);
    this.makeSticky()
    this.events()
  }

  _fx()
  {
    this.animate()
    this.reveal()
    this.animateSlideshow()
    this.revealSlideshow()
  }

  animate()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        [this.ref.header,this.ref.controls],
        {
          autoAlpha:0,
          y:10
        },
        {
          autoAlpha:1,
          y:0,
          ease:easesCustom.cubic,
          duration:.6,
          stagger:.2
        }
      )
    ])
    .add([
      gsap.fromTo(
        this.ref.step,
        {
          autoAlpha:0,
          y:60
        },
        {
          autoAlpha:1,
          y:0,
          ease:'quint.out',
          duration:1,
          stagger:.2
        }
      ),
      gsap.fromTo(
        this.ref.progression,
        {
          transformOrigin:'left top',
          scaleX:0,
        },
        {
          scaleX:1,
          ease:'quint.inOut',
          duration:1,
        }
      )
    ])
  }

  animateSlideshow()
  {
    this.animationSlideshow = gsap.timeline()
    // const coords = this.ref.step[this.VARS.TOTAL_SLIDES].getBoundingClientRect()
    // const viewport = Env.framework.toolbox.getViewport()
    // const translateX = (coords.x - (viewport.width - coords.width)) + this.DOM.landmark.getBoundingClientRect().x
    // console.log(translateX);
    this.animationSlideshow
    .add([
      gsap.fromTo(
        this.ref.slider,
        {
          x:0
        },
        {
          x:this.VARS.SNAPS[this.VARS.TOTAL_SLIDES],
          duration:'quint.out',
          duration:2
        }
      )
    ])
  }

  createSnapsPoints()
  {
    for(let [i,item] of this.ref.step.entries()) {
      const coords = item.getBoundingClientRect()
      const viewport = Env.framework.toolbox.getViewport()
      let translateX;
      if(i > 0 && i < this.VARS.TOTAL_SLIDES) {
        translateX = coords.x - this.DOM.landmark.getBoundingClientRect().x
        this.VARS.SNAPS.push(translateX * -1)
      } else if(i == this.VARS.TOTAL_SLIDES) {
        translateX = (coords.x - (viewport.width - coords.width)) + this.DOM.landmark.getBoundingClientRect().x
        this.VARS.SNAPS.push(translateX * -1)
      }
    }
  }

  events()
  {
    this.ref.btnPrev[0].addEventListener('click',()=>{
      this.moveScroll('-')
    })
    this.ref.btnNext[0].addEventListener('click',()=>{
      this.moveScroll('+')
    })
  }

  listener(st)
  {
    let steps = []
    const limit =  1 / (this.VARS.TOTAL_SLIDES + 1)
    for (const [i, item] of this.ref.step.entries()) {
      const limitMin = i * limit
      const limitMax = (i+1) * limit
      if(st.progress >= limitMin && st.progress < limitMax) {
        this.VARS.NEW_SLIDE = i
      }
    }
  }


  makeSticky()
  {
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:'top top',
      end: ()=>{
        const viewport = Env.framework.toolbox.getViewport()
        return `+=${viewport.height * this.VARS.RATIO_VIEWPORT}px`
      },
      pin:true,
      pinSpacing:true,
      invalidateOnRefresh: true,
    })
    // Skin change
    this.stSkin = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:'top top+=60px',
      end: ()=>{
        const viewport = Env.framework.toolbox.getViewport()
        return `+=${viewport.height * this.VARS.RATIO_VIEWPORT + (viewport.height - 100)}px`
      },
      pin:false,
      pinSpacing:false,
      invalidateOnRefresh: true,
      markers:false,
      onEnter:()=>{
        Env.$html.classList.add(this.VARS.skinValue)
      },
      onEnterBack:()=>{
        Env.$html.classList.add(this.VARS.skinValue)
      },
      onLeave:()=>{
        Env.$html.classList.remove(this.VARS.skinValue)
      },
      onLeaveBack:()=>{
        Env.$html.classList.remove(this.VARS.skinValue)
      }
    })
  }

  moveScroll(direction)
  {
    let index
    if(direction == '+') {
      index = this.VARS.NEW_SLIDE + 1
    } else {
      index = this.VARS.NEW_SLIDE - 1
    }
    const posY = this.DOM.anchorInTheFlow.getBoundingClientRect().top + Env.framework.toolbox.scrollPosition().scrollY
    let ratioMove
    let offset = 0
    //? If index is not first and last, move full
    const viewportRatio = Env.framework.toolbox.getViewport().height * this.VARS.RATIO_VIEWPORT
    if(index > 0 && index < this.VARS.TOTAL_SLIDES) {
      ratioMove = viewportRatio / (this.ref.step.length)
      offset = 2
    //? If index is first and last, move less
    } else {
      ratioMove = viewportRatio / (this.ref.step.length - 1)
    }
    gsap.to(window, {
      scrollTo: ((ratioMove*index)+posY)+offset,
      duration: .7,
      ease:'quint.inOut'
    });
  }


  revealSlideshow()
  {
    this.stSlideshow = ScrollTrigger.create({
      animation:this.animationSlideshow,
      trigger:this.DOM.view,
      start:'top top',
      end: ()=>{
        const viewport = Env.framework.toolbox.getViewport()
        return `+=${viewport.height * this.VARS.RATIO_VIEWPORT}px`
      },
      markers:false,
      scrub:1,
      onUpdate:(e)=>{
        this.listener(e)
        gsap.set(
          this.ref.progressbar,
          {
            transformOrigin:'left top',
            scaleX:e.progress
          }
        )
      }
    })
  }

  reveal()
  {
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:'top 10%',
      markers:false
    })
  }

  unmount()
  {
    this.st.kill(true)
    this.stSlideshow.kill(true)
    this.stSkin.kill(true)
  }
}
